















































































































































import Vue from 'vue'
import { TranslateResult } from 'vue-i18n'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import { hexToRgba } from '@/services/hex-to-rgba'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel, DxScrolling, DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { ResponseBase, UpsertAbonnementeResponse } from '@/types/service-response'
import {
  DELETE_SUBSCRIPTION,
  FETCH_COMMISSION_SUBSCRIPTIONS,
  FETCH_COMMISSION_SUBSCRIPTIONS_METADATA, UPSERT_SUBSCRIPTION
} from '@/store/action-types'
import { UpsertAbonnementeRequest } from '@/types/payload'
import { CommissionSubscription } from '@/model/commissions/CommissionSubscription'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { CommissionLookupProject } from '@/model/commissions/CommissionLookupProject'
import { keyActionService } from '@/services/key-action-service'
import { KeyAction } from '@/model/KeyAction'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}

interface ComponentData {
  tableHeight: string
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  showDeleteDialog: boolean
  loading: boolean
  saveLoading: boolean
  rules: Array<Function>
  dateRules: any[]

  lieferkonditionList: any[]
  mitarbeiterList: any[]
  periodenList: any[]
  projekteList: CommissionLookupProject[]
  prozessartenList: any[]
  versandartList: any[]
  zahlungskonditionList: [],
  subscriptionsList: CommissionSubscription[]
  selectedIndex: number | null
  selectedSubscriptionId: number | null
  selectedSubscription: CommissionSubscription | null
  isEdit: boolean

  art: any | null
  title: string
  menu1: boolean
  menu2: boolean
  start: string | null
  startFormatted: string | null
  end: string | null
  endFormatted: string | null
  leferung: any | null
  versand: any | null
  zahlung: any | null
  ihreReferenz: string
  periode: any | null
  projekt: any | null

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'CommissionSubscriptions',

  components: {
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring,
    DeleteDialog
  },

  props: {
    commissionId: Number
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      showDeleteDialog: false,
      loading: false,
      saveLoading: false,
      rules: [(value: any): boolean | string => !!value || ''],
      dateRules: [
        (value: string | null) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value && value.length >= 1 ? pattern.test(value) || 'Falsche Datum.' : true
        },

        (value: string | null) => {
          return value && value.length !== 10 ? 'Falsche Datum.' : true
        },
        (value: any): boolean | string => !!value || ''
      ],

      lieferkonditionList: [],
      mitarbeiterList: [],
      periodenList: [],
      projekteList: [],
      prozessartenList: [],
      versandartList: [],
      zahlungskonditionList: [],
      subscriptionsList: [],
      selectedIndex: null,
      selectedSubscriptionId: null,
      selectedSubscription: null,
      isEdit: false,

      art: null,
      title: '',
      menu1: false,
      menu2: false,
      start: null,
      startFormatted: null,
      end: null,
      endFormatted: null,
      leferung: null,
      versand: null,
      zahlung: null,
      ihreReferenz: '',
      periode: null,
      projekt: null,

      keyActions: []
    }
  },

  watch: {
    commissionId (newVal: number): void {
      if(newVal) {
        this.isEdit = false
        this.fetchSubscriptionList()
      }
    },

    selectedIndex(newVal: number): void {
      const form: any = this.$refs['form']
      form.resetValidation()
      this.setValues()
    },

    startFormatted (newVal: string | null): void {
      if(newVal && moment(newVal, 'DD.MM.YYYY').isValid()) {
        this.start = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.start = null
      }
    },

    endFormatted (newVal: string | null): void {
      if(newVal && moment(newVal, 'DD.MM.YYYY').isValid()) {
        this.end = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.end = null
      }
    }
  },

  computed: {
    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    isSubscriptionBeforeDisabled (): boolean {
      return this.selectedIndex === 0 || this.subscriptionsList.length === 0
    },

    isSubscriptionAfterDisabled (): boolean {
      return this.selectedIndex === this.subscriptionsList.length -1 || this.subscriptionsList.length === 0
    },
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | null): boolean {
      if(action instanceof Create) {
        return true
      } else if(action instanceof Edit) {
        return !!this.selectedSubscriptionId || !this.isEdit
      } else if(action instanceof Delete) {
        return !!this.selectedSubscriptionId || !this.isEdit
      } else {
        return false
      }
    },

    formatDate(item: string): string {
      return moment(item).isValid() ? moment(item).format('DD.MM.YYYY') : ''
    },
    getPeriode (item: number): string {
      const foundItem: any | undefined = this.periodenList.find((i: any) => i.Wert === item)
      return foundItem ? foundItem.Bezeichnung : ''
    },
    getProzessArt (item: number): string {
      const foundItem: any | undefined = this.prozessartenList.find((i: any) => i.ID === item)
      return foundItem ? foundItem.Bezeichnung : ''
    },
    getLieferkondition (item: number): string {
      const foundItem: any | undefined = this.lieferkonditionList.find((i: any) => i.ID === item)
      return foundItem ? foundItem.Bezeichnung : ''
    },
    getZahlungskondition (item: number): string {
      const foundItem: any | undefined = this.zahlungskonditionList.find((i: any) => i.ID === item)
      return foundItem ? foundItem.Bezeichnung : ''
    },
    getVersandart (item: number): string {
      const foundItem: any | undefined = this.versandartList.find((i: any) => i.ID === item)
      return foundItem ? foundItem.Bezeichnung : ''
    },

    onDateStartChange (date: string): void {
      this.startFormatted = moment(date).format('DD.MM.YYYY')
    },

    onDateEndChange (date: string): void {
      this.endFormatted = moment(date).format('DD.MM.YYYY')
    },

    onFocusStart (): void {
      setTimeout(() => {
        if(!this.menu1) {
          this.menu1 = true
        }
      }, 100)
    },

    onBlurStart (): void {
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onFocusEnd (): void {
      setTimeout(() => {
        if(!this.menu2) {
          this.menu2 = true
        }
      }, 100)
    },

    onBlurEnd (): void {
      setTimeout(() => {
        if(this.menu2) {
          this.menu2 = false
        }
      }, 100)
    },

    onAddSubscriptionClick ():void {
      this.create()
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.isEdit = true
      this.selectedIndex = null
      this.selectedSubscriptionId = null
      this.selectedSubscription = null
      //@ts-ignore
      this.$refs.dataGrid.instance.selectRows([])

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    },

    onEditSubscriptionClick ():void {
      this.update()
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.isEdit = true

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    },

    onSubscriptionBeforeClick (): void {
      this.isEdit = false
      if(!this.selectedIndex) {
        this.selectedIndex = 0
      }
      this.selectedIndex -= 1
      this.selectedSubscriptionId = this.subscriptionsList[this.selectedIndex].id
      this.selectedSubscription = this.subscriptionsList[this.selectedIndex]
      //@ts-ignore
      this.$refs.dataGrid.instance.selectRows([this.selectedSubscriptionId])
    },

    onSubscriptionAfterClick (): void {
      this.isEdit = false
      if(!this.selectedIndex) {
        this.selectedIndex = 0
      }
      this.selectedIndex += 1
      this.selectedSubscriptionId = this.subscriptionsList[this.selectedIndex].id
      this.selectedSubscription = this.subscriptionsList[this.selectedIndex]
      //@ts-ignore
      this.$refs.dataGrid.instance.selectRows([this.selectedSubscriptionId])
    },

    onDeleteSubscriptionClick ():void {
      this.delete()
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.showDeleteDialog = true
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      this.showDeleteDialog = false
      this.deleteSubscription()
    },

    async deleteSubscription (): Promise<void> {
      try {
        this.loading = true
        const response: ResponseBase = await this.$store.dispatch(DELETE_SUBSCRIPTION, this.selectedSubscriptionId)
        if (!response.IsError) {
          this.selectedIndex = null
          this.selectedSubscriptionId = null
          this.selectedSubscription = null
          this.fetchSubscriptionList()
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted').toString()
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.loading = false
      }
    },

    onCancelClick (): void {
      this.isEdit = false
      const form: any = this.$refs['form']
      form.resetValidation()
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if(form.validate()) {
        this.upsertSubscription()
      }
    },

    async upsertSubscription (): Promise<void> {
      const payload: UpsertAbonnementeRequest = {
        ID: this.selectedSubscriptionId,
        Kommission: this.commissionId,
        Prozessart: this.art,
        Titel: this.title,
        Lieferkondition: this.leferung,
        Zahlungskondition: this.zahlung,
        Versandart: this.versand,
        Start: this.start!,
        Ende: this.end!,
        Periode: this.periode,
        IhreReferenz: this.ihreReferenz,
        Projekt: this.projekt
      }

      try {
        this.saveLoading = true
        const response: UpsertAbonnementeResponse = await this.$store.dispatch(UPSERT_SUBSCRIPTION, payload)
        if (!response.IsError && response.aboId) {
          this.selectedSubscriptionId = response.aboId
          this.isEdit = false
          this.fetchSubscriptionList()
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved').toString()
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.saveLoading = false
      }
    },

    onRowClick (rowData: any): void {
      this.selectedIndex = this.subscriptionsList.indexOf(rowData.data)
      this.selectedSubscriptionId = rowData.data.id
      this.selectedSubscription = rowData.data
    },

    setValues (): void {
      if((this.selectedIndex || this.selectedIndex === 0)&& this.subscriptionsList[this.selectedIndex]) {
        this.selectedSubscriptionId = this.subscriptionsList[this.selectedIndex].id
        this.selectedSubscription = this.subscriptionsList[this.selectedIndex]
        this.art = this.selectedSubscription.prozessArt
        this.title = this.selectedSubscription.titel
        this.menu1 = false
        this.menu2 = false
        this.start = this.selectedSubscription.start && moment(this.selectedSubscription.start).isValid() ? moment(this.selectedSubscription.start).format('YYYY-MM-DD') : null
        this.startFormatted = this.start ? moment(this.start).format('DD.MM.YYYY') : null
        this.end = this.selectedSubscription.ende && moment(this.selectedSubscription.ende).isValid() ? moment(this.selectedSubscription.ende).format('YYYY-MM-DD') : null
        this.endFormatted = this.end ? moment(this.end).format('DD.MM.YYYY') : null
        this.leferung = this.selectedSubscription.lieferkondition
        this.versand = this.selectedSubscription.versandart
        this.zahlung = this.selectedSubscription.zahlungskondition
        this.ihreReferenz = this.selectedSubscription.ihreReferenz
        this.periode = this.selectedSubscription.periode
        this.projekt = this.selectedSubscription.projekt
      } else {
        this.art = null
        this.title = ''
        this.menu1 = false
        this.menu2 = false
        this.start = null
        this.startFormatted = null
        this.end = null
        this.endFormatted = null
        this.leferung = null
        this.versand = null
        this.zahlung = null
        this.ihreReferenz = ''
        this.periode = null
        this.projekt = null
      }
    },

    async fetchSubscriptionList (): Promise<void> {
      try {
        const response: any = await this.$store.dispatch(FETCH_COMMISSION_SUBSCRIPTIONS, this.commissionId)
        if(response && !response.IsError && response.Data) {
          this.subscriptionsList = CommissionSubscription.createListFromResponse(response.Data)
          if(this.selectedSubscriptionId) {
            const foundSubscription: CommissionSubscription | undefined = this.subscriptionsList.find((item: CommissionSubscription) => item.id === this.selectedSubscriptionId)
            this.selectedIndex = foundSubscription ? this.subscriptionsList.indexOf(foundSubscription) : null
          }
          this.selectedIndex = this.selectedIndex ? this.selectedIndex : this.subscriptionsList.length > 0 ? 0 : null
          this.selectedSubscriptionId =  this.selectedIndex && this.subscriptionsList[this.selectedIndex] ? this.subscriptionsList[this.selectedIndex].id : null
          this.selectedSubscription = this.selectedIndex && this.subscriptionsList[this.selectedIndex] ? this.subscriptionsList[this.selectedIndex] : null
          this.setValues()
          let selectedRowKeyList: number[] = this.selectedSubscriptionId ? [this.selectedSubscriptionId] : []
          setTimeout(() => {
            //@ts-ignore
            this.$refs.dataGrid.instance.selectRows(selectedRowKeyList)
          }, 100)
        } else {
          this.messageSnackbar =  response.Result ? response.Result : this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchSubscriptionMetaData (): Promise<void> {
      try {
        const response: any = await this.$store.dispatch(FETCH_COMMISSION_SUBSCRIPTIONS_METADATA)
        if(response && !response.IsError && response.Data) {
          this.lieferkonditionList = response.Data.Lieferkondition
          this.mitarbeiterList = response.Data.Mitarbeiter
          this.periodenList = response.Data.Perioden
          this.projekteList = CommissionLookupProject.createListFromResponse(response.Data.Projekte)
          this.prozessartenList = response.Data.Prozessarten
          this.versandartList = response.Data.Versandart
          this.zahlungskonditionList = response.Data.Zahlungskondition
        } else {
          this.messageSnackbar =  response.Result ? response.Result : this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    onResize (): void {
      if(this.$refs.formSection && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.formSection as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 232px - ${height}px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    }

  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
    ]
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)
    setTimeout(() => { this.onResize() }, 0)
    this.fetchSubscriptionMetaData()
    this.fetchSubscriptionList()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
